/* eslint-disable */
import 'jcarousel';
import 'jquery.cookie';
import ls from 'local-storage';
import moment from "moment";
import 'moment/locale/ru';
import getStore from '@ve/services/getStore/getStore';

import '@/js/common/components/emptySerp/found-by-another-date.css'
import '@/js/common/components/emptySerp/view-similar-tours.css'
import '@/js/common/components/emptySerp/search__call-me-back.css'

import getTourProductsFromHotels from '@/js/common/Domain/Service/getTourProductsFromHotels';
import firstPaymentDefinitionService from '@/js/common/Domain/Service/firstPaymentDefinition';
import getTourProductFirstPaymentDefinitions from '@/js/common/Domain/Service/hotelSearch/services/getTourProductFirstPaymentDefinitions';

import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import Search from "@/js/common/Domain/Service/Search";
import {getBlockCountries} from "@/js/common/Domain/Service";
import ADVCakeService from "@/js/common/Domain/Service/ADVCake";
import TourCriteriaObjectValue from "@/js/common/Domain/ObjectValue/TourCriteria";
import fromRouterHydrator from "@/js/common/Domain/Hydrator/fromRouter";
import toRouterHydrator from "@/js/common/Domain/Hydrator/toRouter";
import SearchFormAutocompleteView from '@/js/desktop/components/searchFormAutocomplete/SearchFormAutocomplete';
import SearchPageView from '@/js/desktop/View/SearchPage';
import CovidBannerView from "@/js/common/components/covidBanner";
import ProgressBar from '@/js/desktop/components/progressBar/progress-bar';
import PriceCalendarView from "@/js/common/components/PriceCalendar/PriceCalendar";
import FinishSearchWithEmptySerpService from "@/js/common/Domain/Service/FinishSearchWithEmptySerp";
import SearchRouter from '@/js/common/Domain/Router/SearchRouter';
import searchSessionService from "@/js/common/Domain/Service/search/searchSession";
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import toLocalStorageTourCriteriaHydrator from "@/js/common/Domain/Hydrator/toLocalStorageTourCriteria";
import CountriesRepository from '@/js/common/Domain/Repository/Countries';
import toRouterHotelHydrator from "@/js/common/Domain/Hydrator/toRouterHotel";
import gaAsync from "@/js/common/Domain/Service/gaAsync";
import PriceRangeFactory from "@/js/common/Domain/Factory/PriceRange";
import getShowcasePath from '@/js/common/Domain/Service/getShowcasePath';
import { NAMESPACE as MAP_FOR_SEARCH_FORM } from '@ve/pages/serp/store/SearchFormStore';

import ExpiredPopupView from "@/js/desktop/components/expiredPopup/ExpiredPopup";
import ResortsFilterView from "@/js/desktop/components/search/resortsFilter/ResortsFilter";
import VisaWarningView from "@/js/desktop/components/search/visaWarning/VisaWarning";
import NoToursBannerView from "@/js/common/components/no-tours-banner/no-tours-banner";
import searchHistoryService from "@/js/common/Domain/Service/searchHistory";
import differencesTourCriteria from "@/js/common/Domain/Service/differencesTourCriteria";
import DataLayerAnalytics from "@/js/common/Domain/Service/DataLayerAnalytics";
import SearchRequestFactory from "@/js/common/Domain/Factory/SearchRequest";
import { isEmiratesAvailable } from '@features/tourProduct/filterTourProducts';
import SearchPageHotelCardRightBlockSearchTimer from '@ve/components/serpHotelCard/components/SearchPageHotelCardRightBlockSearchTimer';
import updateSerpTitle from '@/js/common/services/updateSerpTitle';

var ADVCake = new ADVCakeService('search');

const AbstractSearchController = Backbone.View.extend({
	currentSearchModel: new TourCriteriaObjectValue(),
	progressBarTimer: 0,

	tourCriteriaForSearchByDefaultsCriteria: null,
	view: null,
	fromRouterHydrator: fromRouterHydrator,
	toRouterHydrator: toRouterHydrator,
	searchOptions: function () {
		return null;
	},
	initAdditionalViews: function(){

	},
	initDataAnalyticsService(){
		this.dataLayerAnalytics = new DataLayerAnalytics({
			step: "searchPage",
			maxStep: 1
		});
	},
	initSearchForm: function () {
		this.searchFormView = new SearchFormAutocompleteView();
	},
	initModels: function () {
		console.time('init');
		var self = this;

		this.initSearchForm();
		this.model = this.searchFormView.model;

		this.initSearchPageView();
	},
	initSearchPageView() {
		this.view = new SearchPageView({
			el: '#forSearchView',
			searchFormViewModel: this.model,
			dataLayerAnalytics: this.dataLayerAnalytics
		});
	},
	initSearchPageHotelCardRightBlockTimer() {
		this.searchPageHotelCardRightBlockTimer = new SearchPageHotelCardRightBlockSearchTimer();
	},
	countDownTimerForUpdatingMinutesAfterSearchStarted() {
		this.searchPageHotelCardRightBlockTimer.startSearchTimer();
	},
	initComponents: function () {
		var self = this;

		this.progressBar = new ProgressBar('#searchProgressBar');



		this.priceCalendar = new PriceCalendarView({
			searchViewModel: this.view.model,
			checkInDateRange: this.model.get('checkInDateRange'),
			parent: this
		});

		new ExpiredPopupView({
			el: '#expiredContainer',
			searchPageViewModel: this.view.model,
			updateResultCallback: function () {
				self.formSubmit({goToHotelPage: false});
			}
		});

		this.resortsFilterView = new ResortsFilterView({
			model: this.model.get('resorts'),
			viewModel: this.view.model,
			parent: this,
			el: '.resortsFilter'
		});

		new VisaWarningView({
			el: '#visaWarning',
			searchPageViewModel: this.view.model
		});

		this.noToursBanner = new NoToursBannerView({
			el: ".js-component-no-tours-banner",
			model: this.view.model,
			controllerModel:this.model
		});

        this.covidBanner = new CovidBannerView({
            el: '.js-component-covid-banner',
            model: this.view.model,
        });

		this.searchFinish = new FinishSearchWithEmptySerpService(this.searchService, this, this.searchOptions());

		this.initAdditionalViews();
	},
    changeFilterAsCriteriaDebounce: _.debounce(function (event, model, context) {
        this.changeFilterAsCriteria(event, model, context);
    }, 1000),
    changeFilterAsCriteria(event, model, context) {
        if (context && (context.initiator === 'view' || context.initiator === 'filtersPopover')) {
            this.formSubmit({goToHotelPage: false, openBooking: false});
        }
    },
	getUpdateUrl: function () {
		var currentTourCriteria = this.model.getTourCriteria(),
			otherCriterias = this.view.getOtherCriterias(),
			paramsForRouter = this.toRouterHydrator(currentTourCriteria, otherCriterias);

		return '?' + $.param(paramsForRouter);
	},
	updateUrl: function (model, value, context, options) {
		var url = this.getUpdateUrl(),
			router = new SearchRouter().getInstance();

		router.go(url, options ? options : {});
	},

    updateFirstPaymentDefinitions() {
        const syncHotels = this.view.model.get('syncHotels');

        if (syncHotels?.length) {
            const tourProducts = getTourProductsFromHotels(syncHotels);
            const firstPaymentDefinitions = getTourProductFirstPaymentDefinitions(tourProducts);

            firstPaymentDefinitionService.setData(firstPaymentDefinitions);
        }
    },

	initEvents() {
		const router = new SearchRouter().getInstance();
		const $toursList = $('.staticContainer.hotelsContainer');

		router.on('route', this.changeRouteInit.bind(this));

		this.model.get('departureCity').on('change:model', this.model.departureCityChanged.bind(this));
		this.model.get('countries').on('change:model', this.model.countriesChanged.bind(this));
		this.model.get('resorts').on('change:model', this.model.resortsChanged.bind(this));
		this.model.get('hotels').on('change:model', this.model.hotelsChanged.bind(this));

		this.model.get('meals').on('change:model', this.changeFilterAsCriteriaDebounce.bind(this));
		this.model.get('hotelCategories').on('change:model', this.changeFilterAsCriteriaDebounce.bind(this));
		this.model.get('warranted').on('change:model', this.changeFilterAsCriteria.bind(this));
		this.model.get('block').on('change:model', this.changeFilterAsCriteria.bind(this));
		this.model.get('directFlight').on('change:model', this.changeFilterAsCriteria.bind(this));

        this.view.model.on('change:syncHotels', this.updateFirstPaymentDefinitions.bind(this));
		this.view.model.on('change:sortStrategy', this.updateUrl.bind(this));
		this.view.model.get('filterCriteria').on('change', this.updateUrl.bind(this));
		this.view.model.on('change:loadingState', (model, value) => {
			if (this.searchFinish) {
				this.searchFinish.searchFinished(value);
			}
		});

		this.currentSearchModel.on('change', () => {
            const store = getStore();
            const isPairOfDepartureCityAndArrivalCountryAreValid = store.getters[`${MAP_FOR_SEARCH_FORM}/isPairOfDepartureCityAndArrivalCountryAreValid`];
            const country = store.state[MAP_FOR_SEARCH_FORM]?.countries[0];
            const departureCity = store.state[MAP_FOR_SEARCH_FORM]?.departureCity;
			if (!isPairOfDepartureCityAndArrivalCountryAreValid) {
                this.resetDirectFlightFilter();
            }
            if(!isEmiratesAvailable(departureCity, country)) {
                this.resetEmiratesFilter();
            }
            this.goSearch.call(this, this.currentSearchModel);
        });
		this.model.on('startSearch', this.formSubmit.bind(this));
		$('#startSearch, .startSearch').on('click', this.formSubmit.bind(this));
		/* init gallery for static*/

		if (!window.appConfig.noToursFound) {
			$('.js-images-carousel', $toursList).jcarousel({
				list: '.list',
				items: 'li',
				wrap: 'both',
				vertical: false,
			}).on('jcarousel:visiblein', 'li', () => {
				const $element = $('a:not(.btn)', this);
				const imageUrl = $element.data('src');

				if (imageUrl) {
					$element.css('background-image', `url("${imageUrl}")`);
				}
			});

			$('.js-images-carousel-control-prev', $toursList).jcarouselControl({
				target: '-=1',
			});

			$('.js-images-carousel-control-next', $toursList).jcarouselControl({
				target: '+=1',
			});
		}
	},
	resetDirectFlightFilter() {
        this.currentSearchModel.set('directFlight', false, { silent: true });
        this.model.get('directFlight')?.set({ model: false });
        this.updateUrl();
    },
	resetEmiratesFilter() {
        this.currentSearchModel.set('block', false, { silent: true });
        this.model.get('block')?.set({ model: false });
        this.updateUrl();
    },
	startSearchIfControlChanged: null,
	getAdditionalData: function () {
		return {};
	},
	startSearchForce: function () {
		return false;
	},
	resetModel() {
        this.model.get('countries').setNull();
        this.model.get('resorts').setNull();
        this.model.get('hotels').setNull();
        this.model.get('checkInDateRange').setNull();
        this.model.get('nightRange').setNull();
        this.model.get('touristGroup').setNull();
        this.model.get('hotelCategories').setNull();
        this.model.get('meals').setNull();
        this.model.get('priceRange').setNull();
    },
	changeRouteInit: function (type, url) {
		var self = this,
			controlChanged = function () {
				self.view.model.set('beforeToursLoading', false);
				self.changeRouteInit = self.changeRoute;
				self.changeRoute(type, url, additionalData.setTourCriteria);
			},
			additionalData = typeof window.appConfig.defaultTourCriteria !== "undefined" ? window.appConfig.defaultTourCriteria : {};

		url = _.isArray(url) ? url[0] : url;

		additionalData = {setTourCriteria: $.extend({},  this.getAdditionalData(), additionalData)};
		this.startSearchIfControlChanged = controlChanged;

		if (type === "search" || window.appConfig.noToursFound || this.startSearchForce()) {
			this.view.model.set('beforeToursLoading', false);
			this.view.model.set('tourCriteriaLoaded', true);
			self.changeRouteInit = self.changeRoute;
			this.changeRoute(type, url, additionalData.setTourCriteria);
		} else {
			this.resetModel();

			searchSessionService.generateNewSearchId();

			tourCriteriaService.loadTourCriteriaWithFormData(additionalData, {
				success: function (tourCriteria) {
					self.resortsFilterView.populateResortsForStatic(tourCriteria);
					self.model.setTourCriteria(tourCriteria);
					self.view.model.on('change:sortStrategy change:viewMode', controlChanged);
					self.view.model.set('tourCriteriaLoaded', true);
					self.view.model.get('filterCriteria').on('change', controlChanged);
					$('.showMoreBtn').one('click', controlChanged);
					self.model.trigger('formDataLoaded');
				}
			});
		}
	},
	storeCriteria: function (tourCriteria) {
		var paramsForLocalStorage = toLocalStorageTourCriteriaHydrator(tourCriteria);

		ls.set('tourCriteria', paramsForLocalStorage);
	},
	changeRoute: function (type, url, additionalData) {
		var setTourCriteria = {},
			self = this,
			loadTourCriteriaWithFormData = function (params, callback) {
				tourCriteriaService.loadTourCriteriaWithFormData(params, {
					success: function (tourCriteria) {
						self.model.setTourCriteria(tourCriteria);
						callback();
						self.model.trigger('formDataLoaded');
					},
					error: function () {
					}
				});
			};

		if (type === "search") {
			setTourCriteria = this.fromRouterHydrator(_.isArray(url) ? url[0] : url);
		} else {
			if (additionalData) {
				setTourCriteria.tourCriteria = additionalData;
			}
			tourCriteriaService.clearTourCriteriaChangedFields();
		}

		self.view.setOtherCriterias(setTourCriteria.other);
		setTourCriteria = $.extend({}, this.getAdditionalData(), setTourCriteria.tourCriteria);

		this.resetModel();

		loadTourCriteriaWithFormData({setTourCriteria: setTourCriteria}, function () {
			var currentTourCriteria = self.model.getTourCriteria();

			self.updateUrl(null, null, null, {replace: true});

			self.storeCriteria(currentTourCriteria);
			self.currentSearchModel.set(currentTourCriteria.attributes);
			self.view.model.set('searchData', currentTourCriteria);
			self.view.scrollToTop();
			self.model.trigger('formDataLoaded');
		});
	},
	formSubmit: function (params) {
		var goToHotelPage = !(params && params.goToHotelPage === false);
        const shoucaseUrl = getShowcasePath();

		if (!(params && params.notCloseEmptySerpBanners)) {
			this.view.model.closeEmptySearchBanners();
			if (this.noToursBanner) {
				this.noToursBanner.hideBanner();
			}
		}
		if (this.model.getTourCriteria().isValid() && this.searchFormView.isValid()) {
			var self = this,
				departureCityType = this.model.get('departureCity').get('model').get('type'),
				priceRange = CountriesRepository.repository.at(0).get(departureCityType + 'TourCriteria')['priceRange'];


			console.log('Submit search form');
			this.view.model.set('beforeToursLoading', false);

			this.model.get('priceRange').set('model', new PriceRangeFactory(priceRange));
			searchSessionService.changeSearchIdForNewSearch({
				oldSearchCriteria: this.view.model.get("searchData"),
				newSearchCriteria: this.model.getTourCriteria()
			});
			if (differencesTourCriteria({
				oldSearchCriteria: this.view.model.get("searchData"),
				newSearchCriteria: this.model.getTourCriteria()
			})) {
				this.view.model.trigger('differencesFormCriteria');
				this.view.clearFilter({
					currentModel: this.model
				});

			}
			var currentTourCriteria = this.model.getTourCriteria(),
				currentTourCriteriaAttributes = currentTourCriteria.attributes,
				paramsForRouter,
				router = new SearchRouter().getInstance(),
				forceChangeTrigger = _.isEqual(this.currentSearchModel.attributes, currentTourCriteria.attributes),
				goToUrl;

			$.cookie('markSearchSource', true, {path: '/', domain: 'all'});

			this.storeCriteria(currentTourCriteria);

			if (params && params.currentTarget && $(params.currentTarget).is('#startSearch')
				&& currentTourCriteria.get('countries').length == 1) {
				searchHistoryService.addSearch(currentTourCriteria);
			}
			if (goToHotelPage && currentTourCriteria.get('hotels') && currentTourCriteria.get('hotels').length === 1) {
				paramsForRouter = toRouterHotelHydrator({tourCriteria: currentTourCriteria});
				goToUrl = shoucaseUrl + '/hotel/' + currentTourCriteria.get('hotels').at(0).get('id') + '#?' + $.param(paramsForRouter);

				router.go(goToUrl);
			} else {
				if (params && params.openBooking == false) {
					self.updateUrl();
				} else {
					self.updateUrl();
					if(this.dataLayerAnalytics){
						this.dataLayerAnalytics.clickSearchButtonEvent()
					}
				}

				currentTourCriteriaAttributes.track = 1;
				this.currentSearchModel.set(currentTourCriteriaAttributes, {
					resetLoader: true,
					additionalSearch: !!(params && params.additionalSearch)
				});

				//to force search with same params
				if (forceChangeTrigger) {
					this.currentSearchModel.trigger('change', this.currentSearchModel);
				}

				this.view.model.set('subscribe', '0');

				this.view.model.set('searchData', currentTourCriteria);
				this.model.trigger('submitSearch');
			}
		}
	},
	checkFiltersAvailibility: function () {
		var hotels = this.view.model.get('syncHotels'),
			filteredHotels = this.view.model.get('filteredHotels');

		if (!filteredHotels.length && hotels && hotels.length) {
			this.view.clearFilter({currentModel: this.model, onlyPostfilters: true});
		}
	},
	modifyTourCriteria: function (tourCriteria) {
		return tourCriteria;
	},
	analyticsCall: function (tourCriteria) {
		if (this.dataLayerAnalytics.sid !== searchSessionService.getSearchId()) {
			this.dataLayerAnalytics.generateEvent("sid", searchSessionService.getSearchId());
			this.dataLayerAnalytics.initBasicEvents(tourCriteria)
		}
	},
	prepareSearchRequests: function (tourCriteria) {
		return [new SearchRequestFactory(tourCriteria)];
	},
	startSearchTracking(tourCriteria, type) {
        const timestamp = (new Date()).getTime();
        if (type === 'userSearch') {
            trackingService.trackStartSearch({
                tourCriteria,
                timestamp,
                productType: 'TourProduct',
            });
        } else {
            trackingService.trackStartEmptySearch({
                tourCriteria,
                timestamp,
                productType: 'TourProduct',
            });
        }

		mindBoxService.trackViewSerp('serp_main', this.model, this.view.model);
    },
	updateDirectFlightAllowed() {
        const store = getStore();
		const isDirectFlightAllowed = store.getters[`${MAP_FOR_SEARCH_FORM}/isPairOfDepartureCityAndArrivalCountryAreValid`];
		this.view.model.set('isDirectFlightAllowed', isDirectFlightAllowed);
    },
	checkOnBlock: function(tourCriteria, blockCountries) {

		if (!blockCountries || !blockCountries?.data?.length) return false;

		const countries = tourCriteria.get('countries').models;
		const checkInDateRange = tourCriteria.get('checkInDateRange');
		const dateFrom = checkInDateRange.get('from');
		const dateTo = checkInDateRange.get('to');
		let blockedCounter = 0;

		_.each(countries, country => {
			const id = country.get('id');
			const blockCountry = _.findWhere(blockCountries.data, { id });

			if (blockCountry) {
				let isBlockedTour;
				let compareDate;
				if (dateFrom.getTime() !== dateTo.getTime()) compareDate = dateTo
				else compareDate = dateFrom

				isBlockedTour = moment(moment(compareDate).format('YYYY-MM-DD')).isSameOrBefore(blockCountry.disabledBefore);

				if (isBlockedTour) blockedCounter++
			}
		});
		return blockedCounter === countries.length;
	},
	goSearch: async function (tourCriteria, params) {
		updateSerpTitle(tourCriteria);
		this.countDownTimerForUpdatingMinutesAfterSearchStarted();
		this.updateDirectFlightAllowed();

		var searchServiceParamsCollection,
			self = this;
		self.view.model.set('covidBanner', false);
		self.view.model.off('change:sortStrategy change:viewMode', this.startSearchIfControlChanged);
		self.view.model.get('filterCriteria').off('change', this.startSearchIfControlChanged);

        try {
            const blockCountries = await getBlockCountries();

            if (this.checkOnBlock(tourCriteria, blockCountries)) {
                self.view.model.set('covidBanner', true);
                self.view.model.set('loadingState', 'finished');
                self.view.model.hotelsCollection?.reset();

                self.searchService.reset();

                return;
            }
        } catch(error) {
            // TrackJS.track(error);
        }

		if (tourCriteria.isValid() && tourCriteria.get('countries') && tourCriteria.get('countries').length) {
			ADVCake.updateSearchData(tourCriteria);


			this.progressBar.reset();
			this.progressBar.moveToValue(50);

			tourCriteria = this.modifyTourCriteria(tourCriteria);
			self.view.model.trigger('change:syncHotels');

			searchServiceParamsCollection = this.prepareSearchRequests(tourCriteria);

			self.view.model.set('loadingState', 'loading');
			self.view.model.set('loadingInProgress', true);

			var finished = {
				sync: false,
				async: false
			};

			clearInterval(this.progressBarTimer);
			this.progressBarTimer = setInterval(function () {
				if (finished.sync) {
					var asyncStatus = self.searchService.getAsyncStatus(),
						jobsCount = asyncStatus.jobsCount,
						jobsSuccess = asyncStatus.jobsCount,
						jobPercents = 50;
					if (jobsCount && jobsSuccess !== jobsCount) {
						jobPercents += 50 / jobsCount * (jobsSuccess + 1);
					} else {
						jobPercents = 100;
					}
					if (jobPercents === 100) {
						clearInterval(self.progressBarTimer);
					}
					self.progressBar.moveToValue(jobPercents);
				}
			}, 1000);

            this.startSearchTracking(tourCriteria, (params && params.additionalSearch) ? 'emptySearch' : 'userSearch');
			self.searchService.getTours({
                requests: searchServiceParamsCollection,
                clientUuid: trackingService.getClientUuid(),
                customerUuid: trackingService.getCustomerUuid(),
                callback: {
                    sync: (hotels, tourProducts) => {
                        hotels.each(function (hotel) {
                            hotel.initHotelOptions();
                        });

                        if (hotels.length > 0) {
                            if (!finished.async) {
                                self.view.model.set('loadingState', 'asyncLoading');
                            }
                            self.view.model.set('asyncTourProducts', null);
                            self.view.model.set('asyncHotels', null);
                            self.view.model.set('similarHotels', null);
                            self.view.collection.reset();
                            self.view.model.set('pageNumber', 1, { silent: true });
                            self.view.model.set('syncHotels', hotels);
                            self.view.model.set('syncTourProducts', tourProducts);
                            self.view.model.set('loadingInProgress', false);
                            self.view.model.trigger('change:syncHotels');
                            self.view.model.updateRenderedCollection();
                        } else {
                            self.view.model.set('syncHotels', hotels, { silent: true });
                            self.view.model.set('syncTourProducts', tourProducts, { silent: true });
                        }
                        self.view.model.set('firstHotelsPrices', hotels.reduce((memo, hotel) => (memo[hotel.get('id')] = hotel.get('minPrice')) && memo, {}));
                        //todo возможно стоит добавить firstHotelsPrice
                        finished.sync = true;
						if (finished.async) {
							if (self.view.model.get('loadingInProgress')) {
                                self.view.collection.reset();
                                self.view.model.set('pageNumber', 1, { silent: true });
                                if (hotels.length === 0) {
                                    self.view.model.trigger('change:syncHotels');
                                }
                            }
                            self.view.model.updateRenderedCollection();
                            self.view.model.set('loadingInProgress', false);
                            clearInterval(self.progressBarTimer);
							self.progressBar.complete();
								self.view.model.set('loadingState', 'finished');
                        }

                        console.log('changed', 'syncHotels', 'syncTourProducts');
                        self.checkFiltersAvailibility();
                    },
                    middleRequest: (updatedHotels, newHotelsLength) => {
                        _.each(updatedHotels, function (hotel) {
                            hotel.initHotelOptions();
                        });

                        if (newHotelsLength) {
                            self.view.model.trigger('change:syncHotels');
                        }

						if (updatedHotels.length) {
                            self.view.model.set('loadingInProgress', false);
                            self.view.model.updateRenderedCollection();
                            if (finished.async) {
                                clearInterval(self.progressBarTimer);
                                self.progressBar.complete();
                                self.view.model.set('loadingState', 'finished');
                            } else {
                                self.view.model.set('loadingState', 'asyncLoading');
                            }
                        }
                        self.checkFiltersAvailibility();
                    },
                    async: (updatedHotels, newHotelsLength, options) => {
                        var hotels = self.view.model.get('syncHotels');
                        const firstHotelsPrices = self.view.model.get('firstHotelsPrices');
                        const operatorsTime = self.searchService.getAsyncStatus().operators;
                        const tourProducts = self.view.model.get('syncTourProducts');
						const isUserSearch = !params?.additionalSearch;

                        _.each(updatedHotels, function (hotel) {
                            hotel.initHotelOptions();
                        });

                        if (newHotelsLength) {
                            self.view.model.trigger('change:syncHotels');
                        }

                        if (updatedHotels.length) {
                            self.view.model.updateRenderedCollection();
                        }

                        if (isUserSearch) {
                            trackingService.trackSearch({
                                tourCriteria,
                                foundHotels: hotels || {},
                                firstHotelsPrices,
                                foundTourProducts: tourProducts || null,
                                timestamp: options.startSearchTime,
                                firstCacheTime: options.firstCacheTime,
                                searchFinishedTime: options.searchFinishedTime,
                                scannedTours: options.scannedTours,
                                error: options.error,
                                operatorsTime,
                            });
                        }

                        if(self.dataLayerAnalytics && self.dataLayerAnalytics.searchCountEvent) {
                            self.dataLayerAnalytics.searchCountEvent((hotels && hotels.length) ?  hotels.length : 0);
                        }

                        if (hotels && hotels.length === 0 && !self.view.model.get("similarHotels")) {
                            gaAsync(function () {
                                ga('send', 'event', 'SearchResults', 'No_Results', document.location.pathname + document.location.hash, {'nonInteraction': 1})
                            });
                        } else {

                            if (hotels) {
                                gaAsync(function () {
                                    ga('send', 'event', 'SearchResults', hotels.length, document.location.pathname + document.location.hash, {'nonInteraction': 1})
                                });
                            }
                        }

                        finished.async = true;

                        if (finished.sync) {
                            if (self.view.model.get('loadingInProgress')) {
                                self.view.collection.reset();
                                self.view.model.set('pageNumber', 1, { silent: true });
                                if (updatedHotels.length === 0) {
                                    self.view.model.trigger('change:syncHotels');
                                }
                            }
                            self.view.model.updateRenderedCollection();
                            self.view.model.set('loadingInProgress', false);
                            clearInterval(self.progressBarTimer);
                            self.progressBar.complete();
                            self.view.model.set('loadingState', 'finished');
                        }
                        console.log('changed', 'asyncHotels', 'asyncTourProducts', 'loadingState');
                        self.checkFiltersAvailibility();
                    }
				},
				urls: this.searchOptions()
			});

			this.analyticsCall(tourCriteria);
		}
	},
	initSearchService() {
		this.searchService = new Search();
	},
	initialize: function () {
		this.initSearchPageHotelCardRightBlockTimer();
		this.initDataAnalyticsService();
		this.initSearchService();
		this.initModels();
		this.initComponents();
		this.initEvents();
	}
});

export default AbstractSearchController;
